﻿import { useAuthStore } from './modules/app/auth/authstore';
import Dialogs from '@/common/dialogs/dialogs';

class Rest {
    Get(url, config) {
        return axios.get(url, this.getConfig(config))
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                this.processError(error);
                return Promise.reject(error.response);
            });
    }

    Post(url, data, config) {
        return axios.post(url, data, this.getConfig(config))
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                this.processError(error);
                return Promise.reject(error.response);
            });
    }

    Delete(url, config) {
        return axios.delete(url, this.getConfig(config))
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                return this.processError(error);
                //return Promise.reject(error.response);
            });
    }

    getConfig(config) {
        const store = useAuthStore();

        if (!store.auth) {
            return config || {};
        }

        var extended = Object.assign({
                headers: {
                    'Authorization': 'Bearer ' + store.auth.Token,
                    'Content-Type': 'application/json'
                }
            },
            config);

        return extended;
    }

    processError(error) {
        if (error.response.status == 401) {
            let store = useAuthStore();
            store.set(null);
        }
        else if (error.response.status == 403) {
            Dialogs.Error("You do not have access to execute this request");
        }
        else {
            Promise.reject(error.response);
        }
    }
}

export default new Rest();